var text_resizer = (function() {
    // Font size base is 100%
    var fontSize = 150;
    // If fontSize does not equal 100% then decrease font size by 10%
    $("#text-smaller").on("click", function() {
        if (fontSize !== 100) {
            fontSize = fontSize - 10;
            $("html").css("font-size", fontSize + "%");
        }
    });
    // If fontSize is less than 150% then decrease font size by 10%
    $("#text-larger").on("click", function () {
      if (fontSize < 200) {
        fontSize = fontSize + 10;
        $("html").css("font-size", fontSize + "%");
      }
    });
})();
